// Module
var code = "<div class=\"c-datatable-drillableCell ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle\">\n      <div>\n        <a ui-sref=\"index.customercare.customer.cases.detail({caseId: row.entity.id})\" title=\"{{row.entity.caseNumber}}\" ng-bind=\"row.entity.caseNumber\"></a>\n      </div>\n    </div>\n</div>\n";
// Exports
module.exports = code;